import { createRequest, getAccessToken } from './config';

const request = createRequest();

export const Client = {
  createClient: (data) =>
    request.post(`/client`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getClientById: (id) =>
    request.get(`/client/id/${id}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getClientByEmail: (email) =>
    request.get(`/client/email/${email}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getClients: () =>
    request.get("/client", {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getClientsGeneric: (data) =>
    request.put(`/clients/generic`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  updateClientById: (id, data) =>
    request.patch(`/client/id/${id}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  updateClientByEmail: (data, email) =>
    request.patch(`/client/email/${email}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  updateClientsGeneric: (data) =>
    request.patch(`/clients/generic`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    })
};

export default Client;
